import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import NavbarLandingsPage from "../components/NavbarLandingsPage.jsx";
import heroDesktop from '../assets/img_1.png';
import heroMobile from '../assets/img_3.png';
import "./LandingsPage.css";

const LandingPage = () => {
    const navigate = useNavigate();
    const [heroImage, setHeroImage] = useState(heroDesktop);

    // Sample features data
    const features = [
        { title: "Reserveringssysteem", description: "Efficiënt beheer van reserveringen en tafelplanning." },
        { title: "Tafeltoewijzing", description: "Optimaliseer uw zaalindeling voor maximale capaciteit." },
        { title: "Tijd Registratie", description: "Nauwkeurige registratie van personeelsuren." },
        { title: "Planbord", description: "Gestroomlijnde planning voor al uw activiteiten." },
        { title: "Offerte Assistent", description: "Snelle en eenvoudige offertegenerator voor uw zakelijke behoeften." },
        { title: "E-learning Platform", description: "Geavanceerde trainingsmodules voor uw team." }
    ];

    useEffect(() => {
        const updateHeroImage = () => {
            const isMobile = window.innerWidth < 992;
            setHeroImage(isMobile ? heroMobile : heroDesktop);
        };

        updateHeroImage(); // Check once on mount
        window.addEventListener('resize', updateHeroImage);

        return () => {
            window.removeEventListener('resize', updateHeroImage);
        };
    }, []);

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <div className="landing-page">
            <NavbarLandingsPage/>
            <header className="landing-header py-3 text-white" style={{background: '#131517', marginTop: '70px'}}>
                <div className="container">
                    <div className="row align-items-start">
                        <div className="col-md-6 text-center text-md-start pt-3">
                            <h1 className="display-4 fw-bold mb-3" style={{color: '#9E9A9A'}}>
                                Revolutioneer uw horeca met HorecaMasters
                            </h1>
                            <p className="lead mb-3" style={{color: '#fff', fontSize: '1.75rem'}}>
                                De complete, geïntegreerde oplossing
                            </p>
                            <p className="lead mb-4" style={{color: '#fff', fontSize: '1.75rem'}}>
                                voor moderne horecaondernemers.
                            </p>
                            <button
                                onClick={() => handleNavigate('/demo')}
                                className="btn btn-accent btn-lg button-landingspage center-on-small"
                                style={{position: 'relative', paddingRight: '40px'}}
                            >
                                Plan je demo nu
                                <i className="bi bi-arrow-right arrow-icon"></i>
                            </button>
                        </div>
                        <div className="col-md-6 text-center position-relative">
                            <img src={heroImage} alt="MacBook Preview" className="img-hero img-fluid rounded-circle"/>
                        </div>
                    </div>
                </div>
            </header>

            <section id="features" className="py-5 landing-features">
                <div className="container">
                    <h2 className="fw-bold text-center mb-5">Onze Geavanceerde Features</h2>
                    <div className="row">
                        {features.map((feature, index) => (
                            <div key={index} className="col-md-4 mb-4">
                                <div className="card h-100 shadow-sm border-0">
                                    <div className="card-body">
                                        <h5 style={{color: "#942fd4"}} className="card-title">{feature.title}</h5>
                                        <p className="card-text">{feature.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id="pricing" className="py-5">
                <div className="container text-center">
                    <h2 className="mb-4 fw-bold">Onze Abonnementen</h2>
                    <p className="lead mb-3">Kies het perfecte abonnement voor jouw horecazaak en ontdek de voordelen
                        van HorecaMasters.</p>
                    <p className="text-muted mb-4">
                        <strong>Let op:</strong> HorecaMasters is momenteel in de <strong>bètafase</strong>.
                        Functies en prijzen kunnen nog aangepast worden. Maak gebruik van deze kans om tegen een lager
                        tarief deel te nemen en ons te helpen verbeteren!
                    </p>
                    <div className="row justify-content-center"> {/* Center the remaining cards */}
                        {/* Basic Package */}
                        <div className="col-md-4 mb-4"> {/* Changed to col-md-4 for better centering */}
                            <div className="card h-100 shadow border-0 rounded">
                                <div className="card-body d-flex flex-column">
                                    <h5 style={{color: "#942fd4"}} className="card-title fw-bold">HorecaMasters Basic</h5>
                                    <p className="display-6 fw-bold text-dark">€75<span className="fs-6">/maand excl. BTW</span>
                                    </p>
                                    <p className="display-10 text-dark">Alles wat je nodig hebt voor een efficiënte personeelsplanning en nauwkeurige urenregistratie.</p>
                                    <ul className="list-unstyled text-start mt-3">
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span><b>Simpel</b> en snel roosteren</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span><b>Planning</b> automatisch overnemen als gewerkte uren</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span><b>HR</b> basis</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span><b>Geen limiet aan het aantal werknemers</b></span>
                                        </li>
                                    </ul>
                                    {/* Toegevoegde Button */}
                                    <a href="https://buy.stripe.com/28o6s6gI719qeKAfZ1"
                                       className="btn btn-gradient-purple rounded-pill fw-bold px-4 py-2 mt-auto"
                                       style={{
                                           background: "linear-gradient(to right, #942fd4, #7a29ab)",
                                           color: "white",
                                           boxShadow: "0 4px 15px rgba(148, 47, 212, 0.3)",
                                           border: "none",
                                           transition: "all 0.3s ease"
                                       }}
                                       onMouseOver={(e) => {
                                           e.currentTarget.style.transform = "translateY(-3px)";
                                           e.currentTarget.style.boxShadow = "0 8px 20px rgba(148, 47, 212, 0.4)";
                                           e.currentTarget.style.background = "linear-gradient(to right, #a346e6, #8b30c0)";
                                       }}
                                       onMouseOut={(e) => {
                                           e.currentTarget.style.transform = "translateY(0)";
                                           e.currentTarget.style.boxShadow = "0 4px 15px rgba(148, 47, 212, 0.3)";
                                           e.currentTarget.style.background = "linear-gradient(to right, #942fd4, #7a29ab)";
                                       }}
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Start Vandaag
                                    </a>

                                </div>
                            </div>
                        </div>

                        {/* Professional Package
                        <div className="col-md-4 mb-4">
                            <div className="card h-100 shadow border-0 rounded">
                                <div className="card-body d-flex flex-column">
                                    <h5 style={{color: "#942fd4"}} className="card-title fw-bold">Ultimate</h5>
                                    <p className="display-6 fw-bold text-dark">€299<span
                                        className="fs-6">/maand excl. BTW</span>
                                    </p>
                                    <p className="display-10 text-dark">Alles wat je nodig hebt om u horeca bedrijf te
                                        revolutioneren.</p>
                                    <ul className="list-unstyled text-start mt-3">
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span>Alles uit Basic</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span>Offerte Assistent </span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span>Cocktail database</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span>Koffie database</span>
                                        </li>
                                        <li className="mb-2 d-flex align-items-start">
                                            <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                                            <span>E-learning platform</span>
                                        </li>
                                    </ul>
                                    <a href="https://buy.stripe.com/3cs7wafE3f0ggSI7su"
                                       className="btn btn-gradient-purple rounded-pill fw-bold px-4 py-2 mt-auto"
                                       style={{
                                           background: "linear-gradient(to right, #942fd4, #7a29ab)",
                                           color: "white",
                                           boxShadow: "0 4px 15px rgba(148, 47, 212, 0.3)",
                                           border: "none",
                                           transition: "all 0.3s ease"
                                       }}
                                       onMouseOver={(e) => {
                                           e.currentTarget.style.transform = "translateY(-3px)";
                                           e.currentTarget.style.boxShadow = "0 8px 20px rgba(148, 47, 212, 0.4)";
                                           e.currentTarget.style.background = "linear-gradient(to right, #a346e6, #8b30c0)";
                                       }}
                                       onMouseOut={(e) => {
                                           e.currentTarget.style.transform = "translateY(0)";
                                           e.currentTarget.style.boxShadow = "0 4px 15px rgba(148, 47, 212, 0.3)";
                                           e.currentTarget.style.background = "linear-gradient(to right, #942fd4, #7a29ab)";
                                       }}
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        start vanda
                                    </a>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </section>

            <section id="contact" className="py-5 text-white demo-section">
                <div className="container text-center">
                    <h2 className="mb-3">Klaar om uw horeca te transformeren?</h2>
                    <p className="lead mb-2">Ontdek hoe HorecaMasters u kan helpen met een persoonlijke
                        demo. <br/>
                        Wij komen vrijblijvend langs om het softwarepakket te presenteren en het
                        volledig naar wens in te vullen.</p>
                    <div className="button-wrapper">
                        <button onClick={() => handleNavigate('/demo')}
                                className="btn btn-accent btn-lg button-landingspage">
                            Boek een demo
                        </button>
                    </div>
                </div>
            </section>

    <footer className="text-white py-3" style={{background: '#131517'}}>
        <div className="container">
            <div className="row gy-3">
                {/* Company column */}
                <div className="col-12 col-md-4 text-center text-md-start">
                    <h3 className="h6 mb-2">HorecaMasters</h3>
                    <p className="text-secondary mb-0 medium">
                        &copy; 2024 HorecaMasters.<br/>
                        Alle rechten voorbehouden.
                    </p>
                </div>

                {/* Social Media column */}
                <div className="col-12 col-md-4 text-center">
                    <h3 className="h6 mb-2">Volg ons</h3>
                                        <div className="d-flex justify-content-center gap-3">
                                            <a
                                                href="https://www.facebook.com/profile.php?id=61568664692090"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                            >
                                                <i className="bi bi-facebook"></i>
                                            </a>
                                            <a
                                                href="https://www.instagram.com/horeca_masters"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                            >
                                                <i className="bi bi-instagram"></i>
                                            </a>
                                            <a
                                                href="https://wa.me/31648377546" // Vervang dit door je eigen WhatsApp-nummer
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                            >
                                                <i className="bi bi-whatsapp"></i>
                                            </a>
                                        </div>
                                    </div>

                                    {/* Contact kolom */}
                                    <div className="col-12 col-md-4 text-center text-md-end">
                                        <h3 className="h6 mb-2">Contact</h3>
                                        <div className="d-flex flex-column gap-1 align-items-center align-items-md-end">
                                            <a
                                                href="mailto:info@horeca-masters.nl"
                                                className="text-white text-decoration-none d-inline-flex align-items-center gap-2 small"
                                            >
                                                <i className="bi bi-envelope small"></i>
                                                info@horeca-masters.nl
                                            </a>
                                            <a
                                                href="tel:+31648377546"
                                                className="text-white text-decoration-none d-inline-flex align-items-center gap-2 small"
                                            >
                                                <i className="bi bi-telephone small"></i>
                                                06 4837 7546
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </div>
                    );
                    };

                    export default LandingPage;
